export const API_URL_DEV = 'http://localhost:8080/api';
export const API_URL_PROD = 'https://my-couper.herokuapp.com/api';
